import React from "react";
import { ListItemButton, Avatar, Stack, Typography, Box } from "@mui/material";
import { Badge } from "@mui/material";
import { formatNotificationTimestamp } from "./util/formatNotificationTimestamp";
import { getNotificationIcon, getClinicalNotificationBody } from "./util/notificationHelpers";

export default function NotificationItem({ notification, onClick }) {
  const getMessageNotificationBody = () => {
    const metadata = notification.metadata || {};
    return (
      <Typography variant="body2">
        <Box component="span" fontWeight={500}>
          {metadata.sender_name || "Unknown"}
        </Box>{" "}
        <Box component="span" color="text.secondary">
          sent a message to
        </Box>{" "}
        <Box component="span" fontWeight={500}>
          AnswersNow
        </Box>
      </Typography>
    );
  };

  const getNotificationBody = () => {
    switch (notification.type) {
      case "message":
        return getMessageNotificationBody();
      case "clinical":
        return getClinicalNotificationBody(notification);
      default:
        return <Typography variant="body2">Unknown notification type</Typography>;
    }
  };

  return (
    <ListItemButton
      onClick={() => onClick(notification)}
      alignItems="flex-start"
      sx={{
        padding: "16px",
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        borderRadius: "12px",
      }}
    >
      <Badge
        variant="dot"
        color="warning"
        overlap="circular"
        invisible={notification.is_read}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        sx={{
          mr: "12px",
          "& .MuiBadge-badge": {
            border: "1px solid white",
            transform: "scale(1.2) translate(45%, 50%)",
          },
        }}
      >
        <Avatar
          sx={{
            width: 32,
            height: 32,
            "& svg": {
              width: 20,
              height: 20,
            },
          }}
        >
          {getNotificationIcon(notification)}
        </Avatar>
      </Badge>
      <Stack gap={"5px"} flex={1}>
        <Stack direction="row" alignItems="flex-start">
          <Box sx={{ flex: 1, minWidth: 0 }}>{getNotificationBody()}</Box>
          <Typography
            sx={{
              marginLeft: "auto",
              whiteSpace: "nowrap",
              flexShrink: 0,
              ml: 1,
            }}
            variant="caption"
            color="secondary"
          >
            {formatNotificationTimestamp(notification.created_at)}
          </Typography>
        </Stack>
        {notification.type === "message" && (
          <Typography
            sx={{
              maxWidth: 400,
              whiteSpace: "nowrap",
              overflow: "hidden",
              textOverflow: "ellipsis",
            }}
            variant="body2"
            color="text.secondary"
          >
            {notification.content}
          </Typography>
        )}
      </Stack>
    </ListItemButton>
  );
}
